export const SETTINGS_ROUTE = {
  name: 'Settings',
  path: 'settings',
};
